import { Application } from '@shared/models/business/application.model';
import { BodyType } from '@shared/models/business/body-type.model';
import { UsageType } from '@shared/models/business/usage-type.model';

export class VehicleUsage {
	id: number;
	application: Application;
	bodyType?: BodyType;
	usageType?: UsageType;
	contractMonth: number;
	contractYear: number;
	dailyMileage: number;
	yearlyMileage: number;
	operatingDaysPerYear: number;
	shiftPerDay: number;
}
